var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "h-full",
    },
    [
      _c(
        "el-header",
        { attrs: { height: "42px" } },
        [
          _vm._t("form-options", function () {
            return [
              _c(
                "div",
                { staticClass: "flex flex-row justify-end align-center" },
                [
                  _vm._l(_vm.pageData.formOptions, function (option) {
                    return [
                      option === "add"
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.optionBtnShow([
                                    "edit",
                                    "details",
                                    "copy",
                                  ]),
                                  expression:
                                    "optionBtnShow(['edit', 'details','copy'])",
                                },
                              ],
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增 ")]
                          )
                        : _vm._e(),
                      option === "edit"
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.optionBtnShow(["details"]),
                                  expression: "optionBtnShow(['details'])",
                                },
                              ],
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改 ")]
                          )
                        : _vm._e(),
                      option === "copy"
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.optionBtnShow([
                                    "edit",
                                    "details",
                                    "copy",
                                  ]),
                                  expression:
                                    "optionBtnShow(['edit', 'details','copy'])",
                                },
                              ],
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制 ")]
                          )
                        : _vm._e(),
                      option === "details"
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.optionBtnShow(["edit", "copy"]),
                                  expression: "optionBtnShow(['edit','copy'])",
                                },
                              ],
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情 ")]
                          )
                        : _vm._e(),
                      option === "save"
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.optionBtnShow([
                                    "edit",
                                    "add",
                                    "copy",
                                  ]),
                                  expression:
                                    "optionBtnShow(['edit', 'add','copy'])",
                                },
                              ],
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v(" 保存 ")]
                          )
                        : _vm._e(),
                      option === "cancel"
                        ? _c(
                            "el-button",
                            {
                              key: option,
                              staticClass: "option-btn",
                              attrs: { size: "small" },
                              on: { click: _vm.infoCancelBtn },
                            },
                            [_vm._v("取消 ")]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _c(
        "el-main",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "ik-info-head",
              attrs: {
                id: "ik-info-head",
                disabled: _vm.pageData.mode === "details",
                inline: true,
                model: _vm.pageData.formData.head,
                "label-width": "108px",
                size: "small",
              },
            },
            _vm._l(_vm.pageData.formItems, function (row) {
              return _c(
                "el-row",
                { key: row.rowIndex },
                _vm._l(row.items, function (col) {
                  return _c(
                    "el-col",
                    {
                      key: col.id,
                      staticClass: "mb-5",
                      attrs: { span: col.span },
                    },
                    [
                      col.type === "select"
                        ? _c(
                            "form-select-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  "key-field": "key",
                                  "value-field": "value",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-select-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "disselect"
                        ? _c(
                            "form-select-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: {
                                  code: col.code,
                                  disabled: col.config.disabled,
                                  name: col.name,
                                  "key-field": "key",
                                  "value-field": "value",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-select-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "group"
                        ? _c(
                            "form-label-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  "data-down": _vm.loading,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-label-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "date"
                        ? _c(
                            "form-date-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-date-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "time"
                        ? _c(
                            "form-time-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-time-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "datetime"
                        ? _c(
                            "form-datetime-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-datetime-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "number"
                        ? _c(
                            "form-number-item",
                            _vm._b(
                              {
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-number-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "oss"
                        ? _c(
                            "form-image-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-image-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "disoss"
                        ? _c(
                            "form-image-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: {
                                  code: col.code,
                                  disabled: col.config.disabled,
                                  name: col.name,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-image-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "file"
                        ? _c(
                            "form-file-item",
                            _vm._b(
                              {
                                attrs: { code: col.code, name: col.name },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-file-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "video"
                        ? _c(
                            "form-video-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-video-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "popup"
                        ? _c(
                            "form-popup-item",
                            _vm._g(
                              _vm._b(
                                {
                                  ref: `popup_${col.code}`,
                                  refInFor: true,
                                  attrs: { code: col.code, name: col.name },
                                  model: {
                                    value: _vm.pageData.formData.head[col.code],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.formData.head,
                                        col.code,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.formData.head[col.code]",
                                  },
                                },
                                "form-popup-item",
                                col.config,
                                false
                              ),
                              col.handleEvent
                            )
                          )
                        : col.type === "disText"
                        ? _c(
                            "form-text-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: {
                                  code: col.code,
                                  disabled: col.config.disabled,
                                  name: col.name,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-text-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "null"
                        ? _c("el-form-item", { attrs: { label: col.name } })
                        : _c(
                            "form-text-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-text-item",
                              col.config,
                              false
                            )
                          ),
                    ],
                    1
                  )
                }),
                1
              )
            }),
            1
          ),
          _vm._t("form-bottom"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }